import type { LaravelPaginationResponse } from '@/interfaces/models/Laravel'
import type { DeploymentModel, DeploymentStorePayload, DeploymentUpdatePayload } from './Model'
import Api from '@/helpers/models/Api'
import axios, { type AxiosResponse } from 'axios'

const apiUrl = import.meta.env.VITE_API_URL

export default class DeploymentsApi extends Api<
	DeploymentModel,
	LaravelPaginationResponse<DeploymentModel>,
	DeploymentStorePayload,
	DeploymentUpdatePayload
> {
	route = 'deployments'

	async pingApp(params: {
		user_id: string | number
	}): Promise<AxiosResponse<{ running: boolean; buildId: string | null }>> {
		return await axios.post(`${apiUrl}/deployments/ping-app`, params)
	}
}
